import React from 'react';
import styled from 'styled-components';
import { ProjectContainer, ProjectTitle, ProjectInfo } from './styles';
import { useLanguage } from '../../contexts/LanguageContext';

const ProjectDescription = styled.div`
  margin-bottom: 30px;
  line-height: 24px;
`;

const ProjectWrapper = styled.div`
  margin-bottom: 40px;
  
  h4 {
    font-size: 20px;
    color: #333;
    margin: 0 0 20px 0;
    font-weight: 600;
  }
  
  p.textleft {
    text-align: left;
    line-height: 24px;
    margin: 15px 0;
  }
  
  img {
    width: 100%;
    max-width: 600px;
    height: auto;
    margin: 20px auto;
    display: block;
    border: 1px solid #eee;
    
    &.img-centered {
      display: block;
      margin: 20px auto;
    }
    
    &.team-image {
      max-width: 500px;
    }
  }
  
  iframe {
    margin: 20px auto;
    display: block;
  }
  
  hr {
    border: none;
    border-top: 1px solid #eee;
    margin: 30px 0;
  }
  
  ul.list-inline {
    list-style: none;
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: 10px;
    
    li {
      b {
        color: #333;
      }
    }
  }
`;

interface ProjectFitCatProps {
}

const ProjectFitCat: React.FC<ProjectFitCatProps> = () => {
  const { t } = useLanguage();
  
  return (
    <ProjectContainer>
      <ProjectTitle>
        <h2>{t('fitcat.title')}</h2>
        <p className="tags">{t('fitcat.role')}</p>
      </ProjectTitle>
      
      <ProjectDescription>
        {t('fitcat.description')}
      </ProjectDescription>
      
      <ProjectInfo>
        <p><b>{t('fitcat.roleLabel')}</b> {t('fitcat.myRole')}</p>
        <p><b>{t('fitcat.skillsLabel')}</b> {t('fitcat.skillsUtilized')}</p>
      </ProjectInfo>

      <ProjectWrapper>
        <h4>{t('fitcat.requirements')}</h4>
        <p>{t('fitcat.requirementsDesc1')}</p>
        <p className="textleft">{t('fitcat.requirementsDesc2')}</p>
      </ProjectWrapper>
      
      <ProjectWrapper>
        <h4>{t('fitcat.prototypesV1')}</h4>
        <img loading="lazy" decoding="async" className="img-responsive img-centered" src="/images/projects/FitCat01-min.webp" alt="FitCat"/>
        <h4>{t('fitcat.prototypesDemo')}</h4>
        <iframe 
          src="https://player.vimeo.com/video/162764417" 
          width="250" 
          height="445" 
          style={{ border: 0 }} 
          allowFullScreen
          title="FitCat Prototypes Demo Version 1"
        ></iframe>
      </ProjectWrapper>

      <ProjectWrapper>
        <h4>{t('fitcat.prototypesV2')}</h4>
        <p className="textleft">{t('fitcat.prototypesV2Desc')}</p>
        <img loading="lazy" decoding="async" className="img-responsive img-centered" src="/images/projects/FitCat02-min.webp" alt="Fitcat"/>
        <h4>{t('fitcat.prototypesDemo')}</h4>
        <h4>{t('fitcat.sketch3')}</h4>
        <img loading="lazy" decoding="async" className="img-responsive img-centered" src="/images/projects/FitCat03-min.webp" alt="Fitcat"/>
        <hr/>
        <h4>{t('fitcat.iosDemo')}</h4>
        <iframe 
          src="https://player.vimeo.com/video/162462556" 
          width="500" 
          height="281" 
          style={{ border: 0 }} 
          allowFullScreen
          title="FitCat iOS Demo - Real App Version 2"
        ></iframe>
      </ProjectWrapper>

      <ProjectWrapper>
        <h4>{t('fitcat.presentationPoster')}</h4>
        <img loading="lazy" decoding="async" className="img-responsive img-centered" src="/images/projects/fitcat-poster-min.webp" alt="poster"/>
      </ProjectWrapper>

      <ProjectWrapper>
        <h4>{t('fitcat.ourTeam')}</h4>
        <img loading="lazy" decoding="async" className="img-responsive img-centered team-image" src="/images/projects/fitcat-team-min.webp" alt="team"/>
      </ProjectWrapper>

      <ProjectWrapper>
        <ul className="list-inline">
          <li><b>{t('fitcat.dateLabel')}</b> {t('fitcat.dateRange')}</li>
          <li><b>{t('fitcat.clientsLabel')}</b> {t('fitcat.clients')}</li>
        </ul>
      </ProjectWrapper>
    </ProjectContainer>
  );
};

export default ProjectFitCat;